import { PrivateChatErrorCode } from './constants';

export function mapPrivateChatSubscribeError(err) {
  const code = err?.code || '';
  if (code === 'permission-denied') {
    return 'Chat could not load (Firestore permission denied). Restart emulators after rules change.';
  }
  if (err?.message?.includes('index')) {
    return 'Chat needs a Firestore index — check the browser console.';
  }
  return err?.message || 'Chat could not load.';
}

export function mapPrivateChatSendError(err) {
  const code = err?.code || '';
  const msg = (err?.message || '').toLowerCase();

  if (err?.message === PrivateChatErrorCode.NOT_FRIENDS) {
    return 'You must be friends to send private messages. If you just accepted a request, restart npm start and confirm emulators use project lockedin-e870d.';
  }
  if (err?.message === PrivateChatErrorCode.MESSAGING_BLOCKED) {
    return 'Messaging is blocked for this player.';
  }
  if (code === 'permission-denied' || msg.includes('permission')) {
    return 'Message not sent — permission denied. Run npm run emulators:restart, sign in (not demo), and confirm you are friends in the emulator.';
  }
  if (code === 'unavailable' || msg.includes('offline')) {
    return 'Firestore is offline. Start emulators (npm run emulators:start) and refresh.';
  }
  return err?.message || 'Could not send message. Try again.';
}

export function mapPrivateChatDeleteError(err) {
  const code = err?.code || '';
  const msg = (err?.message || '').toLowerCase();
  if (code === 'permission-denied' || msg.includes('permission')) {
    return 'Could not clear chat — permission denied.';
  }
  if (code === 'unavailable' || msg.includes('offline')) {
    return 'Firestore is offline. Try again when you are back online.';
  }
  return err?.message || 'Could not clear chat. Try again.';
}

/** Notifications when opening a thread from App shell */
export function blockedOpenChatMessage(friend) {
  if (friend?.blockedByMe) {
    return 'You blocked this player. Unblock them in Friends to message again.';
  }
  return 'You cannot message this player while they have you blocked.';
}
